"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploreProfiles = exports.ExplorePublications = void 0;
const client_1 = require("../../utils/client");
const queries_1 = require("../../utils/queries");
const ExplorePublications = (sortCriteria, publicationTypes, limit) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        client_1.client
            .query(queries_1.EXPLORE_PUBLICATIONS, {
            request: {
                sortCriteria,
                publicationTypes,
                limit,
            },
        })
            .toPromise()
            .then((data) => {
            resolve(data);
        })
            .catch((err) => {
            reject(err);
        });
    });
});
exports.ExplorePublications = ExplorePublications;
const ExploreProfiles = (sortCriteria) => __awaiter(void 0, void 0, void 0, function* () {
    let query = `
  query ExploreProfiles {
    exploreProfiles(request: { sortCriteria: ${sortCriteria} }) {
      items {
        id
        name
        bio
        isDefault
        attributes {
          displayType
          traitType
          key
          value
        }
        followNftAddress
        metadata
        handle
        picture {
          ... on NftImage {
            contractAddress
            tokenId
            uri
            chainId
            verified
          }
          ... on MediaSet {
            original {
              url
              mimeType
            }
          }
        }
        coverPicture {
          ... on NftImage {
            contractAddress
            tokenId
            uri
            chainId
            verified
          }
          ... on MediaSet {
            original {
              url
              mimeType
            }
          }
        }
        ownedBy
        dispatcher {
          address
          canUseRelay
        }
        stats {
          totalFollowers
          totalFollowing
          totalPosts
          totalComments
          totalMirrors
          totalPublications
          totalCollects
        }
        followModule {
          ... on FeeFollowModuleSettings {
            type
            contractAddress
            amount {
              asset {
                name
                symbol
                decimals
                address
              }
              value
            }
            recipient
          }
          ... on ProfileFollowModuleSettings {
          type
          }
          ... on RevertFollowModuleSettings {
          type
          }
        }
      }
      pageInfo {
        prev
        next
        totalCount
      }
    }
  }
  `;
    return new Promise((resolve, reject) => {
        client_1.client
            .query(query)
            .toPromise()
            .then((data) => {
            resolve(data);
        })
            .catch((err) => {
            reject(err);
        });
    });
});
exports.ExploreProfiles = ExploreProfiles;
